function profileVerified({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 51 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.3333 22C27.2267 22 32 17.2267 32 11.3333C32 5.44 27.2267 0.666668 21.3333 0.666668C15.44 0.666668 10.6667 5.44 10.6667 11.3333C10.6667 17.2267 15.44 22 21.3333 22ZM21.3333 6C24.2667 6 26.6667 8.4 26.6667 11.3333C26.6667 14.2667 24.2667 16.6667 21.3333 16.6667C18.4 16.6667 16 14.2667 16 11.3333C16 8.4 18.4 6 21.3333 6ZM5.33333 38C5.86667 36.32 12.1867 33.52 18.56 32.8267L24 27.4933C22.96 27.3867 22.1867 27.3333 21.3333 27.3333C14.2133 27.3333 0 30.9067 0 38V43.3333H24L18.6667 38H5.33333ZM46.9333 23.3333L33.2533 37.12L27.7333 31.5733L24 35.3333L33.2533 44.6667L50.6667 27.0933L46.9333 23.3333Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default profileVerified;
